const taskStatuses = [
  {
    id: 1,
    name: 'new',
    className: ''
  },
  {
    id: 2,
    name: 'on consideration',
    className: ''
  },
  {
    id: 3,
    name: 'assigned',
    className: ''
  },
  {
    id: 4,
    name: 'disclaim',
    className: ''
  },
  {
    id: 5,
    name: 'updated',
    className: ''
  },
  {
    id: 6,
    name: 'cancelled',
    className: ''
  },
  {
    id: 7,
    name: 'reserved',
    className: ''
  },
  {
    id: 8,
    name: 'deleted',
    className: ''
  },
  {
    id: 9,
    name: 'active',
    className: 'active'
  },
  {
    id: 10,
    name: 'unactive',
    className: 'unactive'
  },
  {
    id: 11,
    name: 'stoped',
    className: ''
  },
  {
    id: 12,
    name: 'in progress',
    className: 'in-progress'
  },
  {
    id: 13,
    name: 'finished',
    className: 'finished'
  },
  {
    id: 14,
    name: 'on stock',
    className: 'on-stock'
  },
  {
    id: 15,
    name: 'contract',
    className: 'contract'
  }
]

export default taskStatuses
